import CustomTooltip from "./CustomTooltip";

export default CustomTooltip;
